import { Component, OnDestroy, OnInit } from "@angular/core";
import { ControllerService } from "../shared/services/controller.service";
import { DomSanitizer } from "@angular/platform-browser";
import swal from "sweetalert2";
declare var $: any;

@Component({
    selector: "app-intro",
    templateUrl: "./intro.component.html",
    styleUrls: ["./intro.component.scss"],
    standalone: false
})
export class IntroComponent implements OnInit, OnDestroy {
  itemHeight: number = 580 //  isEducation(environment) ? 620 : 580;

  logos = Array.from(Array(13).keys()).slice(1);

  type: string

  mainHeader: any

  showNext: boolean = false;

  components  = []

  page = 0


  pageObserver = null

  constructor(public controller: ControllerService, private doms: DomSanitizer ) {}

  sanitizeHtml( innerHtml ){
    return this.doms.bypassSecurityTrustHtml( innerHtml )
  }

  ngOnInit() {


    this.page = this.controller.getPage()

    this.type = this.controller.getSectionProperties().type

    if (this.type == 'singlepage') {
      $("body").addClass("full-screen-bg-image background_v2");
    }


    this.components = this.controller.getSectionComponents()

    // get main header from first page.
    const mh = this.components[0] ? this.components[0].elements.find( (it) => it.type === 'main-header') : null
    if( !mh ){
      this.mainHeader = { value:  'Welcome to Hemisphere' }
    }else{
      this.mainHeader = mh
    }

    this.pageObserver = this.controller.getPageObservers().subscribe( (page) => {
      this.page = page
    })
  }

  getStatsClasses( page ){
    let classes = ['stats-container']

    if( page && page.properties && page.properties['stats-classes'] ){
      classes = classes.concat(page.properties['stats-classes'].split(' '))
    }

    return classes.join(' ')
  }

  ngOnDestroy(): void {
    this.pageObserver.unsubscribe()
    $("body").removeClass()
  }


  onIveSeenEverything() {
    this.showNext = true;
  }

  onStart(){
    this.controller.gotoNextSection()
  }

  onNext() {
    this.controller.forwardComponent()
  }

  showAccessibility(){

    const content = `<h1>Accessibility statement.</h1>

    <p>Hemisphere ("we") are committed to delivering training that is accessible for all people, regardless of technology or ability.</p>
<br>

  <p>We strive to comply with the Web Content Accessibility Guidelines (WCAG) 2.1 level AA standards where we can, and we are actively taking steps to further enhance the accessibility of our platform to meet or exceed applicable standards. We welcome participants to take advantage of the following features when completing the training:</p>
<br>
  <ul>

  <li>Accessibility menu: The accessibility menu can be enabled by clicking the icon that appears on the corner of the page.</li>
  <li>Subtitles: Subtitles can be enabled by clicking on the subtitle icon in the bottom left side of Hemisphere’s content player.</li>
  </ul>
<br>
  <p>We regularly test our platform for accessibility using a variety of methods, including manual testing by external consultants. We also welcome feedback from our users on how we can improve the accessibility of our website.</p>
<br>
  <p>If you have any questions or concerns about the accessibility of our platform, please contact us at <a href="mailto:info@hemisphereapp.io">info@hemisphereapp.io</a>.</p>


      `

      swal({
        title: '',
        customClass: 'accessibility-alert',
        html: content,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false
        });
  }
}
